import { createContext, useContext } from "react";

export interface VersionCheckContextValue {
  readonly requestVersionCheck: () => void;
}

export const VersionCheckContext = createContext<VersionCheckContextValue>({
  requestVersionCheck: () => {},
});

/** Ask the root provider to compare this bundle with the deployed web build. */
export const useVersionCheck = () => useContext(VersionCheckContext);
